const s3config = {
    // accessKeyId: "AKIAY4HNGXP6Z5ODSHVC",
    // secretAccessKey: "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",
    accessKeyId: "AKIA4RCAOJNXH5P6GNWI",
    secretAccessKey: "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",
    // new
    // accessKeyId: "AKIA4RCAOJNXBUTHG6MA",
    // secretAccessKey: "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",
}

export default s3config;